import { computed, watch } from 'vue';
import { useRoute } from '#imports';

export function useSearchFilters() {
  const schoolsState = useState('schoolsState', () => []);
  const typesState = useState('typesState', () => []);
  const dateState = useState('dateState', () => []);

  const route = useRoute();

  const initializeSchools = (organizations) => {
    const secondaryOrgs = route.query?.secondary_organizations;
    const secondaryOrgsArray = Array.isArray(secondaryOrgs) ? secondaryOrgs : secondaryOrgs ? [secondaryOrgs] : [];
    schoolsState.value = organizations.map((school) => ({
      name: school.name,
      org_id: school.org_id,
      checked: secondaryOrgsArray.includes(String(school.org_id)),
    }));
  };

  const initializeTypes = (typeOptions) => {
    const queryIndices = route.query?.query_indices;
    const queryIndicesArray = Array.isArray(queryIndices) ? queryIndices : queryIndices ? [queryIndices] : [];

    typesState.value = typeOptions.map((type) => ({
      ...type,
      checked: queryIndicesArray.includes(type.type),
    }));
  };

  const initializeDateOptions = (dateOptions) => {
    dateState.value = dateOptions.map((date) => ({
      name: date.name,
      idx: date.idx,
      checked: date.checked,
      start_date: date.start_date,
      end_date: date.end_date,
    }));
  };

  watch(
    () => route.query,
    (newQuery) => {
      const secondaryOrgs = newQuery?.secondary_organizations;
      const secondaryOrgsArray = Array.isArray(secondaryOrgs) ? secondaryOrgs : secondaryOrgs ? [secondaryOrgs] : [];

      // Update schools state
      schoolsState.value.forEach((school) => {
        school.checked = secondaryOrgsArray.includes(String(school.org_id));
      });

      const queryIndices = newQuery?.query_indices;
      const queryIndicesArray = Array.isArray(queryIndices) ? queryIndices : queryIndices ? [queryIndices] : [];

      typesState.value.forEach((type) => {
        type.checked = queryIndicesArray.includes(type.type);
      });

      dateState.value.forEach((date) => {
        date.checked = newQuery?.start_date === date.start_date;
      });
    },
    { immediate: true, deep: true },
  );

  const selectedSchools = computed(() =>
    schoolsState.value.filter((school) => school.checked).map((school) => school.org_id),
  );

  const selectedTypes = computed(() => typesState.value.filter((type) => type.checked).map((type) => type.type));

  const selectedDate = computed(() => dateState.value.find((date) => date.checked));

  const hasActiveFilters = computed(() => {
    const schoolsActive = selectedSchools.value.length > 0;
    const typesActive = selectedTypes.value.length > 0;
    const dateActive = !!selectedDate.value;

    return schoolsActive || typesActive || dateActive;
  });

  const clearAllFilters = () => {
    schoolsState.value.forEach((school) => (school.checked = false));
    typesState.value.forEach((type) => (type.checked = false));
    dateState.value.forEach((date) => (date.checked = false));
  };

  return {
    schoolsState,
    typesState,
    dateState,

    initializeSchools,
    initializeTypes,
    initializeDateOptions,

    selectedSchools,
    selectedTypes,
    selectedDate,
    hasActiveFilters,

    clearAllFilters,
  };
}
